import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.recentlyUsedMedia

const externalMediaItems = createSelector(
  selector,
  state => state.externalMediaItems
)

export const recentlyUsedMediaSelectors = {
  externalMediaItems
}
